import SeoLandingTemplate, { SeoLandingPageData } from "@/components/marketing/SeoLandingTemplate";

const page: SeoLandingPageData = {
  path: "/interview-tips",
  title: "Interview Tips",
  seoTitle: "Interview Tips That Actually Help | HiredCoach",
  seoDescription:
    "Practical interview tips for answering clearly, sounding confident, and avoiding the mistakes that make strong candidates feel unprepared.",
  heroEyebrow: "Interview tips",
  heroHeadline: "Good interview tips are boring until you actually need them",
  heroSubhead:
    "Clarity wins. Structure wins. Real examples win. Most people know that in theory and still sound scattered once they start talking.",
  heroPrimaryCta: "Get personalized coaching",
  heroPanelEyebrow: "What actually helps",
  heroPanelTitle: "The basics still matter",
  heroPanelBullets: [
    "Answer the question",
    "Use a real example",
    "Pause if you need to",
    "Practice enough that calm does not depend on luck",
  ],
  frameworkTitle: "The stuff that actually makes answers better",
  frameworkBullets: [
    "Answer directly before adding extra detail.",
    "Use examples instead of broad claims about yourself.",
    "Slow down enough to sound deliberate.",
    "Have decent questions ready for the end.",
  ],
  exampleTitle: "What a strong answer sounds like",
  exampleBlocks: [
    "A strong answer feels direct and grounded.",
    "You hear a clear point, a supporting example, and a reason it matters for the role.",
    "There is no scrambling for relevance at the end.",
  ],
  mistakesTitle: "What people do when they start spiraling a bit",
  mistakes: [
    "They talk in circles before getting anywhere.",
    "They stay abstract when an example would help.",
    "They explain every corner of the story.",
    "They forget to connect the example back to the role.",
  ],
  ctaEyebrow: "Coach U + practice",
  ctaTitle: "Get personalized coaching",
  ctaBullets: [
    "Find the shaky parts",
    "Fix them",
    "Stop guessing",
    "Build the reps that make answers land",
  ],
  ctaInfoCard: {
    title: "Coach U interview articles",
    path: "/public-learn",
    description: "Use Coach U for guidance, then practice with AI feedback inside the app.",
  },
  ctaActionTitle: "Get personalized coaching",
  ctaActionDescription: "Find the shaky parts, fix them, and stop guessing whether your answer worked.",
  relatedTitle: "More interview questions worth actually practicing",
  relatedLinks: [
    {
      title: "How to Prepare for an Interview",
      path: "/how-to-prepare-for-an-interview",
      description: "A practical interview preparation guide covering research, answer practice, story prep, and mock interview rehearsal.",
    },
    {
      title: "Common Interview Mistakes",
      path: "/common-interview-mistakes",
      description: "Avoid common interview mistakes with clear examples, fixes, and a CTA to practice with AI feedback before your next interview.",
    },
    {
      title: "Mock Interview Practice",
      path: "/mock-interview-practice",
      description: "Practice mock interviews with AI feedback, sharpen common interview answers, and turn Coach U frameworks into real interview reps.",
    },
  ],
  faqs: [
    { question: "What is the best interview tip for nervous candidates?", answer: "Trust your structure. That usually steadies you faster than trying to talk yourself out of being nervous." },
    { question: "Should interview answers sound polished?", answer: "Clear and intentional, yes. Over-scripted, no. You still want to sound human." },
  ],
};

export default function InterviewTipsPage() {
  return <SeoLandingTemplate page={page} />;
}
